import getIn from 'lodash/get';
import noop from 'lodash/noop';

import * as Utils from '../../../utils';

// eslint-disable-next-line require-yield
export function* trackStartedfromSource(action) {
  const type = getIn(action, 'data.type', null);
  getIn(
    window,
    'DesktopBridge.sourceTypeChange',
    noop,
  )(Utils.SourceType.getDesktopBridgeSourceType(type));
}
